<template>
  <dialog-v2
    :show="showDialog"
    :title="dialogTitle"
    :disable-save-btn="disableSaveBtn"
    save-button-text="Iniciar"
    max-width="600px"
    @close="closeDialog"
    @save="saveDialog">
    <template slot="content">
      <!--
      <v-layout row wrap>
        <v-flex>
          <v-select
            v-model="form.agents"
            :items="agentsList"
            v-validate="'required'"
            data-vv-name="agents"
            data-vv-scope="callCenterStart"
            data-vv-as="agente"
            color="black"
            label="Lista de agentes"
            multiple
            chips
            :error-messages="errors.collect('callList.agents')"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex>
          <v-select
            v-model="form.sqs"
            :items="sqsList"
            v-validate="'required'"
            data-vv-name="sqs"
            data-vv-scope="callCenterStart"
            data-vv-as="grupos"
            color="black"
            label="Grupos de llamadas"
            multiple
            chips
            :error-messages="errors.collect('callList.sqs')"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex>
          <v-switch
            label="Respetar horario"
            v-model="form.respect_hour"
            class="k-blue-linear-text"
            hint="Desactivar si desea llamar sin importar la hora programada de las llamadas."
            :persistent-hint="true"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex>
          <v-switch
            label="Llamar con zoom"
            v-model="form.zoom"
            class="k-blue-linear-text"
            hint="Activar si desea utilizar la aplicacion zoom como audio para las llamadas."
            :persistent-hint="true"/>
        </v-flex>
      </v-layout>
      -->
      <v-layout mb-3>
        <!-- <v-flex md4 pr-1>
          <v-btn outline flat class="w-100 call-type-btn ma-0" @click="form.call_type = 'zoom'">
            <img src="https://zoom.us/docs/image/new/ZoomLogo_112b8a4.png" width="140px">
            <v-icon v-if="form.call_type === 'zoom'" small icon color="green">
              fas fa-check-circle
            </v-icon>
          </v-btn>
        </v-flex> -->
        <!-- <v-flex md4 pl-1>
          <v-btn outline flat class="w-100 call-type-btn ma-0" @click="form.call_type = 'predictive'">
            <img src="https://assets.website-files.com/5e67f74a495c76eb16065e0a/5e6be103049b8a73198f2fc3_Colektia%20logo%20rgb%20-%20png%20-%20900x400px%20-%20300dpi%20-%20color.png" width="160px">
            <v-icon v-if="form.call_type === 'predictive'" small icon color="green">
              fas fa-check-circle
            </v-icon>
          </v-btn>
        </v-flex> -->
        <v-flex md4 offset-md4 pl-1>
          <v-btn outline flat class="w-100 call-type-btn ma-0" @click="form.call_type = 'softphone'">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRujJauFiE7lLurvdinpyVBK6Sa6w2V7sLTk5RhlMdt_iWqM37GizsUB62ByrxxC2u9qA&usqp=CAU" width="160px">
            <v-icon v-if="form.call_type === 'softphone'" small icon color="green">
              fas fa-check-circle
            </v-icon>
          </v-btn>
          <!-- <v-switch
            v-if="form.call_type === 'softphone'"
            label="New server"
            v-model="form.new_server"
            class="k-blue-linear-text"
            :hide-details="true"/> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <!-- <v-flex>
          <v-switch
          label="Recibir llamadas entrantes"
          v-model="form.receive_incoming_calls"
          class="k-blue-linear-text"
          :hide-details="true"/>
        </v-flex> -->
      </v-layout>
      <v-layout row wrap v-if="form.call_type === 'zoom'">
        <v-flex>
          <v-text-field
            v-model="form.zoom_url"
            v-validate="'required'"
            data-vv-name="zoom_url"
            data-vv-scope="callCenterStart"
            data-vv-as="link conferencia"
            color="black"
            label="Link de conferencia"
            :error-messages="errors.collect('callCenterStart.zoom_url')"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="form.call_type === 'zoom'">
        <v-flex md6 pr-3>
          <v-text-field
            v-model="form.conference_id"
            v-validate="'required'"
            data-vv-name="conference_id"
            data-vv-scope="callCenterStart"
            data-vv-as="ID de la conferencia"
            color="black"
            label="ID de la conferencia"
            :error-messages="errors.collect('callCenterStart.conference_id')"/>
        </v-flex>
        <v-flex md6 pl-3>
          <v-text-field
            v-model="form.access_code"
            v-validate="'required'"
            data-vv-name="access_code"
            data-vv-scope="callCenterStart"
            data-vv-as="codigo de seguridad"
            color="black"
            label="Codigo de seguridad"
            :error-messages="errors.collect('callCenterStart.access_code')"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="form.call_type === 'softphone'">
        <v-flex>
          <v-text-field
            v-model="form.extension_number"
            v-validate="'required'"
            data-vv-name="extension_number"
            data-vv-scope="callCenterStart"
            data-vv-as="extension"
            color="black"
            label="Extension"
            :error-messages="errors.collect('callCenterStart.extension_number')"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import _ from 'lodash';
import DialogV2 from '@/components/global/DialogV2';
import callListMixin from '@/mixins/callList';

export default {
  inject: ['$validator'],
  props: {
    callList: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    disableSaveBtn: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    DialogV2,
  },
  mixins: [
    callListMixin,
  ],
  data() {
    const emptyForm = {
      call_type: '',
      zoom_url: '',
      conference_id: '',
      access_code: '',
      extension_number: '',
      receive_incoming_calls: true,
      new_server: false,
    };
    return {
      showDialog: false,
      emptyForm,
      form: _.cloneDeep(emptyForm),
      // sqsList: [],
      // agentsList: [],
    };
  },
  computed: {
    dialogTitle() {
      return 'Iniciar call center';
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
      setTimeout(() => {
        this.form = _.cloneDeep(this.emptyForm);
      }, 300);
    },
    saveDialog() {
      this.$validator.validateAll('callCenterStart')
        .then((validation) => {
          if (validation && this.form.call_type) {
            this.$emit('save', this.form);
          }
        });
    },
  },
  watch: {
    show() {
      this.showDialog = this.show;
      /*
      if (this.show) {
        Promise.all([
          this.axios.get(`call_center/agents?call_list_id=${this.callList.id}`),
          this.getSqsList({
            call_list_id: this.callList.id,
            only_programmed: true,
            user_id: '',
          }),
        ]).then((values) => {
          const allCalls = values[0].data.reduce((a, b) => a += parseInt(b.amount, 10), 0);
          this.agentsList = [
            {
              text: `Todas las llamadas (${allCalls})`,
              value: 'all',
              disabled: false,
            },
            ...values[0].data.map((item) => {
              let name = '';
              if (this.$auth.user().agent_id === item.agent_id) {
                name = 'Mis llamadas';
              } else {
                ({ name } = item);
              }
              return {
                text: `${name} (${item.amount})`,
                value: item.agent_id,
                disabled: false,
              }
            }),
          ];
          this.sqsList = values[1].map(item => ({
            ...item,
            disabled: false,
          }));
          this.sqsList[0] = {
            text: `Todos (${this.sqsList[0].text.match(/\d/g).join('')})`,
            value: 'all',
            disabled: false,
          };
          this.showDialog = true;
        });
      } else {
        this.showDialog = false;
      }
      */
    },
    'form.call_type'() {
      if (this.form.call_type !== 'softphone') {
        this.form.new_server = false;
      }
    },
    /*
    'form.agents'() { // eslint-disable-line
      const isAll = this.form.agents.includes('all');
      this.agentsList = this.agentsList.map(item => ({
        ...item,
        disabled: (isAll && item.value !== 'all') || (!isAll && this.form.agents.length && item.value === 'all'),
      }));
    },
    'form.sqs'() { // eslint-disable-line
      const isAll = this.form.sqs.includes('all');
      this.sqsList = this.sqsList.map(item => ({
        ...item,
        disabled: (isAll && item.value !== 'all') || (!isAll && this.form.sqs.length && item.value === 'all'),
      }));
    },
    */
  },
};
</script>

<style scoped>
.call-type-btn {
  height: 200px !important;
  border: 1px solid #000;
  border-radius: 5px;
  color: rgba(128, 128, 128, 0.72);
  position: relative;
}
.call-type-btn i {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/CallList/Detail/Modal.vue